module.exports = __webpack_public_path__ + "static/media/ac3.84b2983d.jpg";